import EntityEditor from "../../../../../common/Tables/EntityEditor";
import { ValidatedTextInput } from "../../../../../common/inputs/ValidatedInputs";
import { useRatePlansApi } from "../../../../../common/hooks/useRatePlansApi";

const ratePlanEditorStyle = ({ theme }) => ({
    '& .MuiPaper-root': {
        width: '80%',
        maxWidth: '500px'
    }
});

const emptyRatePlan = {
    name: '',
    description: ''
};

const PaymentRulesEditor = ({ propertyId, onSuccess, onClose, editedRatePlan, existingRatePlans }) => {
    const { createRatePlan, updateRatePlan } = useRatePlansApi();

    let defaultRatePlan = editedRatePlan || emptyRatePlan;
    const isEditing = !!editedRatePlan;

    const submitRatePlan = (ratePlan) => {
        const submit = isEditing ? updateRatePlan : createRatePlan;

        return submit(propertyId, {
            ...ratePlan
        });
    }

    const title = isEditing ? `Editing Rate Plan: ${editedRatePlan.name}` : "Creating a new Rate Plan";

    const EditorContent = ({ entity, onChange, disabled, entityChanged }) => {
        const ratePlan = entity;

        return <>
            <ValidatedTextInput
                margin="dense"
                id="name"
                label="Name"
                type="text"
                fullWidth
                required
                unique={{ existingValues: existingRatePlans.map(ratePlan => ratePlan.name).filter(name => !isEditing ? true : name !== editedRatePlan.name) }}
                onChange={onChange}
                disabled={disabled}
                value={ratePlan.name}
                disableError={!entityChanged}
            />
            <ValidatedTextInput
                margin="dense"
                id="description"
                label="Description"
                type="text"
                fullWidth
                multiline
                rows="2"
                onChange={onChange}
                disabled={disabled}
                value={ratePlan.description}
            />
        </>
    };

    return <EntityEditor
        dialogProps={{ sx: ratePlanEditorStyle }}
        title={title}
        defaultEntity={defaultRatePlan}
        entityName='Rate Plan'
        submitAction={submitRatePlan}
        editing={isEditing}
        onClose={onClose}
        onSuccess={onSuccess}
        EditorContent={EditorContent}
    />
}

export default PaymentRulesEditor;